<div class="toast" [class.fade-in]="obsFadeIn.value$ | async" [class.fade-out]="obsFadeOut.value$ | async"
	(swipeleft)="onSwipe()" (swiperight)="onSwipe()" data-cy="toast">
	<div class="content">
		<div class="labels">
			<ion-label *ngIf="obsTitle.value$ | async as title" class="title">{{title}}</ion-label>
			<ion-label *ngIf="obsDescription.value$ | async as description" class="description">{{description}}</ion-label>
		</div>
		<div class="close" *ngIf="(obsCanDismiss.value$ | async) && (obsShowDismissButton.value$ | async)">
			<ion-icon name="close" (click)="onCloseClicked()"></ion-icon>
		</div>
	</div>
	<div *ngIf="obsButtons.value$ | async as buttons" class="buttons">
		<ion-button *ngFor="let button of buttons" [class]="button.style"
			(click)="onButtonClicked(button.id)">{{button.label}}</ion-button>
	</div>
</div>